import { useEffect, useState } from "react";
import { Controller, SubmitHandler, useForm } from "react-hook-form";
import { NumericFormat } from "react-number-format";
import * as S from "./styled";
//Hooks
import useLoading from '../../../../hooks/useLoading';
import apiRequest from "../../../../hooks/apiRequest";
//Components
import LayoutModal from "../../../LayoutModal";
import AddiotionInputs from "../AdditionInputs";
import Loading from "../../../../components/Loading";
//Inteface
import { IPromotion, Inputs } from "Interfaces/IPromotion";
import { IFormPayment } from "Interfaces/IFormPayment";

interface ICreate {
  isOpenModalUpdate: boolean;
  setModalClose: () => void;

  selectedUrlId: number | null;
  updateList: () => void;
}

export default function UpdatePromotion({
  isOpenModalUpdate,
  setModalClose,
  selectedUrlId,
  updateList
}: ICreate) {

  const {
    register,
    control,
    reset,
    setValue,
    getValues,
    resetField,
    handleSubmit: handleFormSubmit,
    formState: { errors },
  } = useForm<Inputs>();


  const { isLoading, startLoading, stopLoading } = useLoading();
  const [formPayment, setFormPayment] = useState<IFormPayment[]>([]);
  const [dataUpdate, setDataUpdate] = useState<IPromotion | null>(null);

  const typeProduct = (type: string) => {
    switch (type) {
      case 'App\\Models\\Lens':
        return 'lens';
      case 'App\\Models\\Frame':
        return 'frame';
      case 'App\\Models\\Accessory':
        return 'accessory';
      case 'App\\Models\\Service':
        return 'service';
    }
  }

  const fetchData = async () => {
    startLoading();
    try {
      const response = await apiRequest<IPromotion>(`promotion/${selectedUrlId}`);
      const dataItems = response.data;
      setDataUpdate(dataItems);

      for (const key in dataItems) {
        if (
          key === 'title' ||
          key === 'auth' ||
          key === 'start' ||
          key === 'end' ||
          key === 'store_credit_discount'
        ) {
          setValue(key as keyof Inputs, dataItems[key]);
        } else if (dataItems.cash_promotions && Array.isArray(dataItems.cash_promotions)) {
          dataItems.cash_promotions.forEach((cashPromo, index) => {
            // Setando o valor de desconto para cada forma de pagamento
            setValue(`cashPromotions.${index}.discount`, parseFloat(cashPromo.discount));
            setValue(`cashPromotions.${index}.form_payment_id`, cashPromo.form_payment.id);
          });
        } else if (dataItems.credit_promotions && Array.isArray(dataItems.credit_promotions))
          dataItems.credit_promotions.forEach((credit, index) => {
            // Setando o valor de desconto para cada promoção de crédito
            setValue(`creditPromotions.${index}.discount`, credit.discount);
            setValue(`creditPromotions.${index}.installment`, credit.installment);
          })
      }
    } catch (error) {
      console.log("Error: ", error);
    } finally {
      stopLoading();
    }
  };

  useEffect(() => {
    if (isOpenModalUpdate && selectedUrlId !== null) {
      fetchData();
    }
  }, [isOpenModalUpdate, selectedUrlId]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await apiRequest<IFormPayment[]>("form-payment");
        const responseData = response.data;

        const filteredPayments = responseData
          .filter((payment) => payment.form_payment !== 'Cartão de Crédito')
          .map((payment) => ({
            ...payment,
            form_payment: payment.form_payment.replace('Cartão de Débito', 'Débito')
          }));

        setFormPayment(filteredPayments);
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };
    fetchData();
  }, []);

  const onSubmit: SubmitHandler<Inputs> = async (data) => {
    startLoading();
    try {
      const promotionItems = dataUpdate?.promotion_items.map((val) => {
        return {
          type: typeProduct(dataUpdate?.promotion_items[0].promotionable_type),
          id: val.id
        }
      })

      const payload = {
        ...data,
        promotionItems
      }

      console.log('payload', payload);

      const response = await apiRequest(
        `promotion/${selectedUrlId}`,
        "PATCH",
        payload
      );
      const status = response.status;
      if (status === 200) {
        alert("Promoção atualizada com sucesso!");
        updateList();
        onClose();
      }
    } catch (error: any) {
      alert(error.message || "Ocorreu um erro ao criar a promoção.");
    } finally {
      stopLoading();
    }
  };

  const onClose = () => {
    setModalClose();
  }

  if (isOpenModalUpdate) {
    return (
      <LayoutModal
        statusLoad={isLoading}
        title="Registrar Promoção"
        subTitle="Preencha os dados da promoção do produto."
        setModalClose={onClose}
        submiteModal={handleFormSubmit(onSubmit)}
        nameSubmit="Atualizar"
      >
        {isLoading || !dataUpdate ? ( // Se estiver carregando ou os dados forem nulos, mostra o loading
          <Loading />
        ) : (
          <S.Container>
            <S.FormInput>
              <S.Label>
                Nível de Autorização
                <span>*</span>
              </S.Label>
              <S.Select
                {...register("auth", { required: true })}>
                <option value="" disabled selected hidden>
                  Selecione
                </option>
                <option value="Administrador">
                  Administrador
                </option>
                <option value="Gerente">
                  Gerente
                </option>
                <option value="Loja">
                  Loja
                </option>
              </S.Select>
              {errors.auth && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.FormInput>
              <S.Label>
                Nome da Promoção
                <span>*</span>
              </S.Label>
              <S.Input
                placeholder="Informe o nome da Promoção"
                type="text"
                {...register("title", { required: true })}
              />
              {errors.title && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>


            <S.FeaturedSection>
              <S.Title>
                Desconto À vista (%)
                <span>*</span>
              </S.Title>
              {formPayment.map((val, index) => (
                <S.FormInput key={val.id}>
                  <S.ContentInput >
                    <S.LabelGray>{val.form_payment || '-'}</S.LabelGray>
                    <Controller
                      name={`cashPromotions.${index}.discount`}
                      rules={{ required: "Campo Obrigatório" }}
                      control={control}
                      render={({ field: { onChange, value, ref } }) => (
                        <NumericFormat
                          thousandSeparator="."
                          decimalSeparator=","
                          decimalScale={2}
                          fixedDecimalScale={true}
                          placeholder="0,00 %"
                          suffix=" %"
                          value={value}
                          onValueChange={(values) => {
                            const discountValue = values.floatValue ?? 0;
                            setValue(`cashPromotions.${index}.form_payment_id`, val.id);
                            onChange(discountValue);
                          }}
                          getInputRef={ref}
                        />
                      )}
                    />

                  </S.ContentInput>
                  {errors.cashPromotions?.[index]?.discount && (
                    <S.InforErro>Campo Obrigatório</S.InforErro>
                  )}
                </S.FormInput>

              ))}
            </S.FeaturedSection>

            <AddiotionInputs
              getValues={getValues}
              register={register}
              errors={errors}
              reset={reset}
              control={control}
              setValue={setValue}
              resetField={resetField}
              creditPromotions={dataUpdate.credit_promotions || []} // Passar os dados da API
            />

            <S.FormInput>
              <S.Label>
                Desconto no Crediário
                <span>*</span>
              </S.Label>
              <Controller
                name={'store_credit_discount'}
                rules={{ required: "Campo Obrigatório" }}
                control={control}
                render={({ field: { onChange, value, ref } }) => (
                  <NumericFormat
                    thousandSeparator="."
                    decimalSeparator=","
                    decimalScale={2}
                    fixedDecimalScale={true}
                    placeholder="0,00 %"
                    suffix=" %"
                    value={value}
                    onValueChange={(values) => {
                      const discountValue = values.floatValue ?? 0;
                      onChange(discountValue);
                    }}
                    getInputRef={ref}
                  />
                )}
              />
              {errors.store_credit_discount && (
                <S.InforErro>Campo Obrigatório</S.InforErro>
              )}
            </S.FormInput>

            <S.SeparateDiv>
              <S.FormInput>
                <S.Label>
                  Período Inicial
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o nome da Promoção"
                  type="date"
                  {...register("start", { required: true })}
                />
                {errors.start && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>

              <S.FormInput>
                <S.Label>
                  Período Final
                  <span>*</span>
                </S.Label>
                <S.Input
                  placeholder="Informe o nome da Promoção"
                  type="date"
                  {...register("end", { required: true })}
                />
                {errors.end && (
                  <S.InforErro>Campo Obrigatório</S.InforErro>
                )}
              </S.FormInput>
            </S.SeparateDiv>
          </S.Container>
        )}
      </LayoutModal>
    );
  }
  return null;
}
